// extracted by mini-css-extract-plugin
export default {"waitingScreen":"UserWaiting_waitingScreen__l1Rzh","waitingImg":"UserWaiting_waitingImg__3GcsB"};